'use client';
import { createContext } from '@chakra-ui/utils/context';

const [NumberInputStylesProvider, useNumberInputStyles] = createContext({
  name: `NumberInputStylesContext`,
  errorMessage: `useNumberInputStyles returned is 'undefined'. Seems you forgot to wrap the components in "<NumberInput />" `
});
const [NumberInputContextProvider, useNumberInputContext] = createContext({
  name: "NumberInputContext",
  errorMessage: "useNumberInputContext: `context` is undefined. Seems you forgot to wrap number-input's components within <NumberInput />"
});

export { NumberInputContextProvider, NumberInputStylesProvider, useNumberInputContext, useNumberInputStyles };
